import { ROLES } from "../const/roles"
import { createJwt } from "../utils/test.helpers"
import { KEYCLOACK_MOCK_EMAIL } from "./keycloackEmail.mock"
import type { PharmUPP_KeycloackInstance } from "./types"

/**
 * Mock Keycloak to avoid to be redirected to Keycloak auth page
 */
export const getKeycloackMock = (
  mockConf: Partial<PharmUPP_KeycloackInstance> & { tokenParsed?: any } = {},
) => {
  const tokenParsed = {
    name: "Jean Mock",
    given_name: "Jean",
    family_name: "Mock",
    // TODO: override this using .env.local file to avoid to commit those changes
    // Change email to activate mocks for special scenarios
    // email: KEYCLOACK_MOCK_EMAIL.DEFAULT,
    // email: KEYCLOACK_MOCK_EMAIL.DOCS_TO_SIGN,
    // email: KEYCLOACK_MOCK_EMAIL.DOCS_TO_SIGN_CRITICAL,
    email: KEYCLOACK_MOCK_EMAIL.NEGATIVE_SEGMENTATION,
    realm_access: {
      // Change role here
      roles: [
        // ROLES.ADMIN,
        // ROLES.UPP_PRESIDENT,
        // ROLES.UPP_REPRESENTATIVE,
        ROLES.ADHERENT_HOLDER,
        // ROLES.ADHERENT_TEAM,
        // ROLES.ADHERENT_ADVISOR,
        // ROLES.EXTERN_CONTACT_LABORATORY,
      ],
    },
    ...mockConf?.tokenParsed,
  }
  const fakeToken = createJwt(tokenParsed)

  return {
    init: () => Promise.resolve(true),
    token: fakeToken,
    updateToken: () => Promise.resolve(fakeToken),
    authenticated: true,
    ...mockConf,
    tokenParsed,
  } as PharmUPP_KeycloackInstance
}
